import React from 'react';
import CLoading from "../CLoading";

const TipoEseTable = ({list}) => {
  
  if(!list){
    return  <CLoading />
  }
  const listRows = list.map((r, index) => {
    
    /*
    * {"is_no_activo":false,
    
    * "isAutBuroReq":true,
    * "isForzarSelPuesto":false,
    * "listaPuestos":[""],
    * "tipo":"buro de credito"}
    * */
    return <tr key={r.id_tipo_ese}>
      <td>
        {index + 1}
      </td>
      <td>
        <h4>{r.tipo}</h4>
        {r.isAutBuroReq ? <div><span className="tag is-warning" title="Incluye  Buró">Buro</span></div> : null}
        {r.isForzarSelPuesto ? (
          <>
            <span className="tag is-warning" title="Require Puesto de la Lista">Puestos Restringidos</span>
            <ul>
              {r.listaPuestos.map(s => <li key={s}>{s}</li>)}
            </ul>
          </>
        ) : null}
      </td>
    
    </tr>
  })
  return (
    <div className="m30B">
      <h2 className="subtitle">
        <i className="fa fa-sitemap m10R"/>
        Tipos de Estudios
      </h2>
      
      <table className="table is-striped is-fullwidth m10T">
        <thead>
        <tr>
          <th className="tdindex">#</th>
          <th>Tipo</th>
        </tr>
        </thead>
        <tbody>
        {listRows}
        </tbody>
      </table>
    
    </div>
  );
};

export default TipoEseTable